import { useState } from 'react';

const BRAND = {
  gradient: 'linear-gradient(135deg, #F97316 0%, #EC4899 50%, #8B5CF6 100%)',
  pink: '#EC4899',
  gray: '#94A3B8',
};

/**
 * Renders Stripe payment buttons — one per location for multi-location deals,
 * or a single button for single-location deals.
 * After opening payment link(s), user self-reports completion to advance.
 */
export default function StripePaymentStep({ stripeLinks, setupFee, onComplete }) {
  const [confirmed, setConfirmed] = useState(false);
  const links = stripeLinks || [];

  const handlePay = (url) => {
    window.open(url, '_blank', 'noopener');
  };

  const handleConfirm = () => {
    setConfirmed(true);
    setTimeout(() => onComplete(), 600);
  };

  if (confirmed) {
    return (
      <div style={{ padding: 14, borderRadius: 12, background: `${BRAND.pink}10`, textAlign: 'center' }}>
        <span style={{ color: BRAND.pink, fontWeight: 600 }}>✓ Payment Complete</span>
      </div>
    );
  }

  // Single location
  if (links.length <= 1) {
    const link = links[0];
    return (
      <div>
        <button
          onClick={() => link && handlePay(link.url)}
          style={{
            width: '100%', padding: 15, borderRadius: 14, border: 'none',
            background: BRAND.gradient, color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer',
            marginBottom: 10,
          }}
        >
          Pay Setup Fee via Stripe — {setupFee || `$${link?.amount || 499}`}
        </button>
        <button
          onClick={handleConfirm}
          style={{
            width: '100%', padding: 12, borderRadius: 12, border: '1px solid rgba(255,255,255,0.15)',
            background: 'rgba(255,255,255,0.04)', color: BRAND.gray, fontSize: 14, cursor: 'pointer',
          }}
        >
          I've completed payment ✓
        </button>
      </div>
    );
  }

  // Multi-location
  return (
    <div>
      <div style={{ fontSize: 13, color: BRAND.gray, marginBottom: 10 }}>
        Setup fee divided across {links.length} locations:
      </div>
      {links.map((link, i) => (
        <button
          key={i}
          onClick={() => handlePay(link.url)}
          style={{
            width: '100%', padding: 13, borderRadius: 12, border: 'none',
            background: BRAND.gradient, color: '#fff', fontSize: 15, fontWeight: 700,
            cursor: 'pointer', marginBottom: 8, opacity: 0.85 + (i * 0.05),
          }}
        >
          Pay Onboarding — {link.locationName} (${link.amount})
        </button>
      ))}
      <button
        onClick={handleConfirm}
        style={{
          width: '100%', padding: 12, borderRadius: 12, border: '1px solid rgba(255,255,255,0.15)',
          background: 'rgba(255,255,255,0.04)', color: BRAND.gray, fontSize: 14,
          cursor: 'pointer', marginTop: 4,
        }}
      >
        I've completed all payments ✓
      </button>
    </div>
  );
}
